<template>
	<div class="">
		<div class="clearfloat">
			<div class="imgs flo_lf" @click="xin.goUrl('/personalCenter/head')">
				<img :src="user.avatar"/>
			</div>
			<div class="message_box flo_lf">
				<div class="user_name">{{user.nickname}}</div>
				<div>您的会员级别为：<span class="user_vip">{{user.type | isVip}}</span></div>
				<div>您回到同仁化学中国！您的上一次登录时间：{{user.last_time*1000 | timeFormat}}</div>
				<!-- <div class="laing_btn history_btn" @click="xin.goUrl('/personalCenter/history')" >历史足迹</div> -->
				<div class="min_he400" v-loading="loading">
					<div class="laing_btn" v-if="user.type !=1" @click="xin.goUrl('/applyVip')">申请VIP</div>
					<p class="cre_title red" v-if="isVip==0">尽快申请VIP，享有订购积分！</p>
					<p class="cre_title red" v-else-if="isVip==1">您的VIP申请已收到，我们后续会尽快进行审核，并联系您!</p>
					<p class="cre_title red" v-else-if="isVip==3">很抱歉您的VIP审核未通过!</p>
					<div class="content_vip" v-html="th"></div>
					<div class="content_vip" v-html="ff"></div>
					<div class="content_vip" v-html="yq"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
	export default{
		data(){
			return {
				isVip:0,//vip申请过程
				loading:true,
				th:"",//vip特惠
				ff:"",//VIP申请方法：
				yq:"",//VIP申请要求：
			}
		},
		computed:{
			...mapState(['user','token'])
		},
		created(){
			this.PostuserCommon();
		},
		methods:{
			async PostuserCommon(){
				let {data:data1} = await this.api.PostUseris_vip();
				this.isVip = data1;
				let {data} = await this.api.PostuserCommon({name:'vou_vip'});
				this.th = data;
				let {data:a} = await this.api.PostuserCommon({name:'vip_apply_way'});
				this.ff = a;
				let {data:b} = await this.api.PostuserCommon({name:'vip_apply_ask'});
				this.yq = b;
				this.loading = false;
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.history_btn{
		width: 180px;
		height: 40px;
	}
	.content_vip{
		margin-top: 30px;
	}
</style>
